import _defineProperty from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * DevExtreme (esm/renovation/common/config_provider.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["children", "rtlEnabled"];
import { BaseInfernoComponent } from "@devextreme/runtime/inferno";
import { ConfigContext } from "./config_context";
export var viewFunction = function viewFunction(viewModel) {
  return viewModel.props.children;
};
export var ConfigProviderProps = {};
export var ConfigProvider = /*#__PURE__*/function (_BaseInfernoComponent) {
  _inherits(ConfigProvider, _BaseInfernoComponent);
  function ConfigProvider(props) {
    var _this;
    _classCallCheck(this, ConfigProvider);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfigProvider).call(this, props));
    _this.state = {};
    _this.__getterCache = {};
    return _this;
  }
  _createClass(ConfigProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return _extends({}, this.context, _defineProperty({}, ConfigContext.id, this.config || ConfigContext.defaultValue));
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState, context) {
      if (this.props.rtlEnabled !== nextProps.rtlEnabled) {
        this.__getterCache.config = void 0;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props),
        config: this.config,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "config",
    get: function get() {
      var _this2 = this;
      if (void 0 !== this.__getterCache.config) {
        return this.__getterCache.config;
      }
      return this.__getterCache.config = function () {
        return {
          rtlEnabled: _this2.props.rtlEnabled
        };
      }();
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props = this.props,
        restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return restProps;
    }
  }]);
  return ConfigProvider;
}(BaseInfernoComponent);
ConfigProvider.defaultProps = ConfigProviderProps;